(function () {
	const accordions = document.querySelectorAll('.accordion');

	if (!accordions.length || accordions === null || accordions === undefined) {
		return;
	}

	class Accordion {
		constructor(accordion) {
			this.accordion = accordion;
			this.id = this.accordion.getAttribute('id');
			this.accordionItems = this.accordion.querySelectorAll('.accordion-item');
			this.triggers = document.querySelectorAll('.accordion-trigger');
			this.activeItem = null;
			this.closeEvent = new CustomEvent('accordion-close', {
				detail: {
					item: null,
				},
			});

			this.openEvent = new CustomEvent('accordion-open', {
				detail: {
					newItem: null,
				},
			});

			this.toggleEvent = new CustomEvent('accordion-toggle', {
				detail: {
					newItem: null,
					prevItem: null,
				},
			});
		}

		init() {
			this.addEventListeners();
			this.checkHash();
		}

		checkHash() {
			const hash = window.location.hash;
			if (!hash) return;
			const item = [...this.accordionItems].find(
				item => item.getAttribute('data-anchor') === hash.split('#')[1]
			);
			this.toggleItem(item);
			this.scrollTo();
		}

		addEventListeners() {
			this.accordionItems.forEach(item => {
				const header = item.querySelector('.accordion-item__header');
				header.addEventListener('click', e => {
					this.toggleItem(item);
				});
			});

			if (this.triggers.length) {
				this.addTriggerListeners();
			}

			window.addEventListener('resize', () => {
				this.resize();
			});
		}

		addTriggerListeners() {
			this.triggers.forEach(trigger => {
				trigger.addEventListener('click', () => {
					const link = trigger.querySelector('a');
					const hash = link.getAttribute('href').split('#')[1];
					const item = [...this.accordionItems].find(
						item => item.getAttribute('data-anchor') === hash
					);

					this.toggleItem(item);

					item.querySelector('.accordion-item__content').addEventListener(
						'transitionend',
						() => {
							// this.scrollTo();
						},
						{ once: true }
					);

					// this.scrollTo();
				});
			});
		}

		scrollTo() {
			let navigationHeight = document.querySelector('.site-header').offsetHeight;
			gsap.to(window, {
				duration: 0.4,
				scrollTo: {
					y: this.activeItem,
					offsetY: navigationHeight,
					// autoKill: false,
				},
				ease: 'power2.out',
			});
		}

		expandItem(item) {
			const itemContent = item.querySelector('.accordion-item__content');
			const heightSetter = item.querySelector('.accordion-item__height-setter');
			const itemHeight = itemContent.querySelector('.accordion-item__wrapper').scrollHeight;
			let transitionDuration = itemHeight * 1.3;
			if (transitionDuration < 350) {
				transitionDuration = 350;
			} else if (transitionDuration > 600) {
				transitionDuration = 600;
			}

			gsap.to(heightSetter, {
				duration: transitionDuration / 1000,
				height: itemHeight,
				ease: 'power2.out',
				onStart: () => {
					item.classList.add('accordion-item--transitioning');
				},
				onComplete: () => {
					window.dispatchEvent(new Event('resize'));
					item.classList.remove('accordion-item--transitioning');
					setTimeout(() => {
						// this.scrollTo();
					}, 200);
				},
			});
		}

		collapseItem(item) {
			const itemContent = item.querySelector('.accordion-item__content');
			const heightSetter = item.querySelector('.accordion-item__height-setter');
			const itemHeight = itemContent.querySelector('.accordion-item__wrapper').scrollHeight;
			let transitionDuration = itemHeight * 1.3;
			if (transitionDuration < 350) {
				transitionDuration = 350;
			} else if (transitionDuration > 600) {
				transitionDuration = 600;
			}

			gsap.to(heightSetter, {
				duration: transitionDuration / 1000,
				height: 0,
				ease: 'power2.out',
				onStart: () => {
					item.classList.add('accordion-item--transitioning');
				},
				onComplete: () => {
					window.dispatchEvent(new Event('resize'));
					item.classList.remove('accordion-item--transitioning');
				},
			});
		}

		toggleItem(item) {
			if (item === null || item === undefined) return;

			// Update the detail properties of the CustomEvent objects
			this.closeEvent.detail.item = item;
			this.openEvent.detail.newItem = item;
			this.toggleEvent.detail.newItem = item;
			this.toggleEvent.detail.prevItem = this.activeItem;

			if (item.classList.contains('accordion-item--transitioning')) return;

			if (this.activeItem === item) {
				window.dispatchEvent(this.closeEvent);
				this.collapseItem(item);
				this.activeItem.classList.remove('accordion-item--active');
				this.activeItem = null;
				return;
			}

			if (this.activeItem) {
				window.dispatchEvent(this.toggleEvent);
				this.collapseItem(this.activeItem);
				this.activeItem.classList.remove('accordion-item--active');
			} else {
				this.expandItem(item);
				window.dispatchEvent(this.openEvent);
			}

			item.classList.add('accordion-item--active');
			this.expandItem(item);
			this.activeItem = item;
		}

		resize() {
			if (this.activeItem) {
				const itemContent = this.activeItem.querySelector('.accordion-item__content');
				const heightSetter = this.activeItem.querySelector('.accordion-item__height-setter');
				const itemHeight = itemContent.querySelector('.accordion-item__wrapper').scrollHeight;
				heightSetter.style.height = `${itemHeight}px`;
			}
		}

		scrollToItem(item) {
			// dispatch a window resize event to update the scroll position

			let navigationHeight = document.querySelector('.site-header').offsetHeight;
			gsap.to(window, {
				duration: 0.6,
				scrollTo: { y: item, offsetY: navigationHeight },
				ease: 'power2.out',
			});
		}
	}

	accordions.forEach(accordion => {
		const instance = new Accordion(accordion);
		instance.init();
	});
})();
